<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">جزئیات حواله</h5>
                <div style="flex: 1"></div>
                <button   
                    class="btn btn-info text-right item-right"  
                    @click="printVarieties"   
                    style="margin-inline: 5px;">  
                    پرینت  
                </button>
                <button   
                    class="btn btn-warning text-right item-right"  
                    @click="barcodeVarieties"   
                    style="margin-inline: 5px;">  
                    چاپ بارکد  
                </button>
                <button   
                    class="btn btn-danger text-right item-right"  
                    @click="cancelHavale"   
                    v-show="hasPermission('cancel_transfer')"
                    style="margin-inline: 5px;">  
                    لغو حواله  
                </button>
                <Back url="/admin/havale" />
            </div>
            <div class="row col-12 mr-2">
                <div class="col-4">
                    <span>شناسه حواله: </span>
                    <span class="font-weight-bold">{{ havale.id }}</span>
                </div>
                <div class="col-4">
                    <span>انبار مبدا: </span>
                    <span class="font-weight-bold">{{ havale.from_store_label }}</span>
                </div>
                <div class="col-4">
                    <span>انبار مقصد: </span>
                    <span class="font-weight-bold">{{ havale.to_store_label }}</span>
                </div>
            </div>
            <div class="row col-12 mr-2 mt-3">
                <div class="col-4">
                    <span>فروشنده: </span>
                    <span class="font-weight-bold">{{ havale.transmitter_full_name }}</span>
                </div>
                <div class="col-4">
                    <span>زمان ثبت: </span>
                    <span class="font-weight-bold">{{ havale.created_at | persianDate }}</span>
                </div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">آیتم های حواله</h5>
                <div style="flex: 1"></div>
            </div>
            <div class="p-5">
                <b-table
                    id="main-table"
                    bordered
                    striped
                    :fields="fields"
                    :items="items"
                    responsive="sm"
                    >
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(quantity)="data" class="d-flex justify-content-center">
                        <div class="d-flex justify-content-center">
                            <b-form-input type="number" v-model="data.item.quantity" style="max-width: 80%;"/>
                        </div>
                    </template>
                    <template v-slot:cell(delete)="data">
                        <button
                            type="button"
                            v-show="hasPermission('cancel_transfer')"
                            class="action-btns1 pt-1 px-1"
                            @click="deleteItem(data.index,data.item.id,data.item.quantity)"
                        >
                            <i class="feather feather-trash-2 text-danger"></i>
                        </button>
                    </template>
                </b-table>
            </div>
        </div>
    </main>
</template>
<script>
    import {
        BTable,
        BFormGroup,
        BFormInput,
        BTr,
        BTd,
        BButton,
        BModal,
    } from "bootstrap-vue";
    import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
    import ShowVarietiesModal from "@@/core/components/report/ShowVarietiesModal";
    import configProvider from "@@/core/configProvider";
    import Back from "@@/core/components/shared/Back/Back";

    export default {
    name: "HavaleShow",
    components: {
        ShowVarietiesModal,
        DatePickerRange,
        BTable,
        BFormGroup,
        BFormInput,
        Back,
        BTr,
        BTd,
        BButton,
        BModal,
    },
    configProvider,
    data() {
        return {
            havale: [],
            items: [],
            index: 1,
            fields: [
                {
                    key: "index",
                    label: "ردیف",
                },
                {
                    key: "variety_title",
                    label: "محصول",
                },
                {
                    key: "quantity",
                    label: "تعداد انتقال",
                },
                {
                    key: "delete",
                    label: "لغو ایتم",
                },
            ],
            id: this.$route.params.id,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        printVarieties() {  
            this.showModal = false;  
            const url = `/admin/print-havale?id=${this.havale.id}`;
            window.open(url, '_blank');  
        },  
        barcodeVarieties() {  
            this.showModal = false;  
            const url = `/admin/print-barcodes?id=${this.havale.id}`;
            window.open(url, '_blank');  
        },  
        async loadData(){
            try {
                const response = await this.$axios.get("admin/store_transfers/" + this.id);
                this.havale = response.data.data.transfer;
                this.items = response.data.data.items;
                console.log(this.havale);
            } catch (e) {
                this.$root.notify(e);
            }
        },
        async cancelHavale(){
            window
            .swal({
                title: "حواله لغو شود؟",
                text: "این عملیات غیر قابل بازگشت خواهد بود",
                icon: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                dangerMode: true,
                buttons: ["بازگشت", "بله لغو کن"],
            })
            .then((willDelete) => {
            if (willDelete) {
                this.$axios
                .post('admin/store-transfers/rollback?store_transfer_id=' + `${this.havale.id}`)
                .then((response) => {
                    window.swal({
                        icon: "success",
                        showConfirmButton: true,
                        text: response.data.message,
                        button: "باشه",
                    });
                })
                .catch((error) => {
                    window.swal({
                        title: "���",
                        showConfirmButton: true,
                        text: error.response.data.message,
                        button: "باشه",
                    });
                });
            }
            })
            .catch(() => {});
        },
        async deleteItem(index,itemId,quantity){
            window
            .swal({
                title: "ایتم لغو شود؟",
                text: "این عملیات غیر قابل بازگشت خواهد بود",
                icon: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                dangerMode: true,
                buttons: ["بازگشت", "بله لغو کن"],
            })
            .then((willDelete) => {
            if (willDelete) {
                this.$axios
                .post('admin/store-transfers/items/' + `${itemId}` + '/rollback',{quantity: quantity})
                .then((response) => {
                    location.reload();
                    window.swal({
                        icon: "success",
                        showConfirmButton: true,
                        text: response.data.message,
                        button: "باشه",
                    });
                })
                .catch((error) => {
                    window.swal({
                        title: "���",
                        showConfirmButton: true,
                        text: error.response.data.message,
                        button: "باشه",
                    });
                });
            }
            })
            .catch(() => {});
        }
    },
};
</script>
<style>
</style>
